var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-500 -1584)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(500 1584)",
    fill: "#fff",
    stroke: "#bebebe",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    rx: 11.5,
    ry: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    x2: 11,
    transform: "translate(506.5 1595.5)",
    fill: "none",
    stroke: "#00488E",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 11,
    transform: "translate(512 1590) rotate(90)",
    fill: "none",
    stroke: "#00488E",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/add-plus.9f3d59beca141b9a9ef060e10f354586.svg";
export { ForwardRef as ReactComponent };